enum MediaType {
  AUDIO = 0,
  VIDEO = 1,
}

export default MediaType;
